import { createResource, type RouteResource } from 'react-resource-router';

import { eocCommonResources, type UserResourceType } from '@atlassian/eoc-resources';

import type { MaintenanceResponse, UserRightsResponse } from '../../common/types';
import { getMaintenance, getMaintenanceUserRights } from '../endpoints';

export const maintenanceResource: RouteResource<MaintenanceResponse> = createResource({
	type: 'maintenanceResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `maintenance/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return getMaintenance(teamId);
	},
	isBrowserOnly: true,
});

export const maintenanceUserRightsResource: RouteResource<UserRightsResponse> = createResource({
	type: 'maintenanceUserRightsResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `maintenance-user-rights/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return getMaintenanceUserRights(teamId);
	},
	isBrowserOnly: true,
});

export const resources = (): (
	| RouteResource<UserResourceType>
	| RouteResource<MaintenanceResponse>
	| RouteResource<UserRightsResponse>
)[] => [...eocCommonResources(), maintenanceResource, maintenanceUserRightsResource];
